<template>
  <div v-if="false">
    <div
      class="p-4 absolute w-screen h-screen bg-black bg-opacity-30 flex flex-col gap-4 z-50"
    >
      <div
        v-for="notification in orderedNotifications"
        :key="notification.id"
        class="notification"
        :class="notification.type"
      >
        <div class="flex justify-between items-center">
          <div>
            <b class="capitalize">{{ notification.type }}:</b>
            {{ notification.message }}
          </div>
          <button class="p-3" @click="removeNotification(notification.id)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="w-5 h-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const notificationsStore = useNotificationsStore()

const orderedNotifications = computed(() => {
  return notificationsStore.notifications.sort(
    (a, b) => b.timestamp.valueOf() - a.timestamp.valueOf()
  )
})

const removeNotification = (id: string) => {
  notificationsStore.removeNotification(id)
}
</script>

<style lang="postcss" scoped>
.notification {
  @apply pl-4 pr-1  border rounded;
}

.notification.info {
  @apply text-blue-500 border-blue-300 bg-blue-100;
}

.notification.error {
  @apply text-red-500 border-red-300 bg-red-100;
}
</style>
